var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"color/all",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M12 2a9 9 0 0 0-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7a9 9 0 0 0-9-9z","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }